import { render, staticRenderFns } from "./hdTabs.vue?vue&type=template&id=2320ca81&scoped=true"
import script from "./hdTabs.vue?vue&type=script&lang=js"
export * from "./hdTabs.vue?vue&type=script&lang=js"
import style0 from "./hdTabs.vue?vue&type=style&index=0&id=2320ca81&prod&lang=css"
import style1 from "./hdTabs.vue?vue&type=style&index=1&id=2320ca81&prod&scoped=true&lang=css"
import style2 from "./hdTabs.vue?vue&type=style&index=2&id=2320ca81&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2320ca81",
  null
  
)

export default component.exports